import React from 'react';
import './footer.css'

const Footer = () => {
    return (
        <div>
            <div className="footer-container">
                <small class="copyRight">Copyright © 2021 <br /> Enjoy Your Trips with The Travel </small>


            </div>
        </div>
    );
};

export default Footer;